export default {"gitHash":"ba3230bbb0a9b560ee1a873bdd4a0d44cf2f6dab","gitHashShort":"ba3230b","time":1675616131965,"platform":"linux","arch":"x64"};